// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
// import { getTokenData } from '@utils'

export const getAllData = createAsyncThunk('appChargeBack/getAllData', async () => {
  const response = await axios.get('/vt/chargebacks')
  console.log('respo', response)
  return response.data
})

export const getData = createAsyncThunk('appChargeBack/getData', async params => {

  const response = await axios.get('/vt/chargebacks', { params: { ...params } })
  return {
    params,
    data: response.data.data.rows,
    totalPages: response.data.data.count
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get(`/users/${id}`)
  return response.data.data
})

export const appChargeBackSlice = createSlice({
  name: 'appChargeBack',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    tranData: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appChargeBackSlice.reducer
